$(document).ready(function(){
  // Membership Package Form
  $("#membership-plan").change(function(){
    var membership_plan_id = $(this).val();
    getMembershipPlanPrice(membership_plan_id);
  });

  function getMembershipPlanPrice(id){
    $.ajax({
      type: "GET",
      dataType:"json",
      url: `/admin/membership_plans/${id}/get_plan_price`,
      success: function(response) {
        $("#membership-plan-price").val(response.price)
      }
    });
  };

  $("#subtitle").keyup(function (){
    updateDisplayDescription();
  })

  $("#membership-plan").change(function(){
    updateDisplayDescription();
  });

  function updateDisplayDescription() {
    var membership_plan_id = $("#membership-plan").val()
    var subtitle = $("#subtitle").val()
    $.ajax({
      type: "GET",
      dataType:"json",
      data: {'membership_plan_id' : membership_plan_id, 'subtitle' : subtitle},
      url: "/admin/membership_packages/get_display_description",
      success: function(response){
        $("#display_description").val(response['description'])
      }
    });
  }

  // START ADMIN PAGE
  $("#submit-button-membership-plan").click(function() {
    var status = $("#select-membership-status").val();
    var title  = $("#input-title").val();

    if (status == 'active') {
      text_alert = I18n.t('global.notices.are_you_sure') + `\n${title} ` + I18n.t('global.notices.is_current_active_membership_plan')
    } else {
      return true
    }

    if (confirm(text_alert)) {
      return true
    } else {
      return false
    }
  });
  // END ADMIN PAGE
});